import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	// Step 1 messages
	stepOneHeadline: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.step-one.headline',
		defaultMessage: 'Your plans start here',
		description: 'Headline for the first step of the export Jira context to page spotlight tour',
	},
	stepOneBody: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.step-one.body',
		defaultMessage:
			"We've embedded your Jira timeline into this doc so you can work while staying in sync across platforms.",
		description: 'Body text for the first step of the export Jira context to page spotlight tour',
	},

	// Step 2 messages
	stepTwoHeadline: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.step-two.headline',
		defaultMessage: 'Share to keep everyone in sync',
		description: 'Headline for the second step of the export Jira context to page spotlight tour',
	},
	stepTwoBody: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.step-two.body',
		defaultMessage:
			'Share this page with your team so everyone can see the latest updates in real time.',
		description: 'Body text for the second step of the export Jira context to page spotlight tour',
	},

	// Step 3 messages
	stepThreeHeadline: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.step-three.headline',
		defaultMessage: 'Keep building this doc',
		description: 'Headline for the third step of the export Jira context to page spotlight tour',
	},
	stepThreeBody: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.step-three.body',
		defaultMessage: 'Type / to insert elements like headers, tables, columns and more.',
		description: 'Body text for the third step of the export Jira context to page spotlight tour',
	},

	// Common action buttons
	next: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.actions.next',
		defaultMessage: 'Next',
		description: 'Button label to proceed to the next step of the spotlight tour',
	},
	back: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.actions.back',
		defaultMessage: 'Back',
		description: 'Button label to go back to the previous step of the spotlight tour',
	},
	done: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.actions.done',
		defaultMessage: 'Done',
		description: 'Button label to complete the spotlight tour',
	},
	dismiss: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.actions.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Button label to dismiss the spotlight tour',
	},
	stepCount: {
		id: 'experiment-export-jira-context-nudge.spotlight-tour.step-count',
		defaultMessage: '{current} of {total}',
		description: 'Step count indicator showing current step and total steps',
	},
});
